export const getStoreOptions = (stores, availableIds) =>
  stores
    ? stores
        .filter(({ id }) => availableIds.includes(id))
        .map((store) => ({
          value: store.id,
          label: store.name
        }))
        .asMutable()
    : [];
